















import { defineComponent, PropType, toRefs, watch, ref, Ref } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, SpuInfo } from '@tt4b/ttam-enums';
import { useIsEcomShop, useSelectedSpu, getProductAmount, useShopInfo } from './hooks';
import ProductSelectMain from './subcpn/main.vue';

const name = 'ttam-product-select-from-shop-new-compose';
export default defineComponent({
  name,
  components: {
    ProductSelectMain,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      required: true,
    },
    piniaData: {
      type: Object as PropType<{
        productList: Ref<Array<SpuInfo>>;
      }>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, piniaData } = toRefs<{
      adgroupData: AdgroupFormData;
      campaignData: CampaignFormData;
      piniaData: {
        productList: Ref<Array<SpuInfo>>;
      };
    }>(props);

    const shopInfo = useShopInfo({ adgroupData });
    const isEcomShop = useIsEcomShop(shopInfo);
    const isSingleSelect = ref(true);

    const { spuListAmount } = getProductAmount({
      adgroupData,
      campaignData,
      shopInfo,
    });

    const { selectedSpuList, resetSelected } = useSelectedSpu({
      spuDetailList: piniaData.value.productList,
    });

    const next = () => {
      if (selectedSpuList.value.length) {
        emit('next', selectedSpuList.value);
      }
    };

    const init = () => {
      const hasSelectAvailableProducts = selectedSpuList.value.some(spu => !spu.isDisabled);
      emit('valid-status', hasSelectAvailableProducts);
    };

    watch(
      () => selectedSpuList.value?.some(spu => !spu.isDisabled),
      val => {
        emit('valid-status', val);
      },
    );

    return {
      name,
      shopInfo,
      isEcomShop,
      selectedSpuList,
      isSingleSelect,
      next,
      init,
      spuListAmount,
    };
  },
});
